/**
 * ProjectResourceService
 * Service for ProjectResource entity operations
 * Route: api/project-resources
 * Controller: ProjectResourceController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * ProjectResourceService
 * Handles project resource CRUD operations
 * Maps to /api/project-resources endpoint
 */
export class ProjectResourceService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProjectResourceService.DEFAULT_SERVICE_PATH,
            basePath: ProjectResourceService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
ProjectResourceService.DEFAULT_SERVICE_PATH = 'projects';
ProjectResourceService.BASE_PATH = 'api/project-resources';
//# sourceMappingURL=ProjectResourceService.js.map